type Translate = (key: string, options?: Record<string, unknown>) => string;

interface EpisodeFooterNavProps {
  show: boolean;
  prevEpisodeId: string | null;
  nextEpisodeId: string | null;
  t: Translate;
  onNavigateEpisode: (episodeId: string) => void;
}

export default function EpisodeFooterNav({
  show,
  prevEpisodeId,
  nextEpisodeId,
  t,
  onNavigateEpisode,
}: EpisodeFooterNavProps) {
  if (!show) return null;

  return (
    <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', margin: '1rem 0' }}>
      <button
        className="btn btn-ghost"
        disabled={!prevEpisodeId}
        onClick={() => prevEpisodeId && onNavigateEpisode(prevEpisodeId)}
      >
        {t('nav.prevEpisode')}
      </button>
      <button
        className="btn btn-ghost"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
        {t('nav.backToTop')}
      </button>
      <button
        className="btn btn-ghost"
        disabled={!nextEpisodeId}
        onClick={() => nextEpisodeId && onNavigateEpisode(nextEpisodeId)}
      >
        {t('nav.nextEpisode')}
      </button>
    </div>
  );
}
